namespace $.$$ {
	export class $shm_hitalama_skills extends $.$shm_hitalama_skills {
		@ $mol_mem
		override List() { const list = super.List(); list.head_content = ()=> [ list.Head_title(), this.Help() ]; return list }
		selected( next?: string ) { return this.$.$mol_state_arg.value( 'skill', next ) ?? '' }
		catalog() { return this.$.$shm_hitalama_skills_catalog.current()! }
		entry( id: string ) {
			const entry = this.catalog()?.entry( id )
			if( !entry ) throw new Error( 'Скилл не найден в каталоге.' )
			return entry
		}
		selected_entry() { return this.entry( this.selected() ) }
		skill_pages() { return [ this.List(), ...( this.repository_opened() ? [ this.Repository() ] : [] ), ...( this.selected() ? [ this.Viewer(), ...( this.editing() ? [ this.Editor() ] : [] ) ] : [] ) ] }
		@ $mol_mem
		editing_id( next = '' ) { return next }
		editing( next?: boolean ) {
			if( next !== undefined ) this.editing_id( next ? this.selected() : '' )
			return Boolean( this.selected() && this.editing_id() === this.selected() )
		}
		@ $mol_action
		close_editor( event?: Event ) { if( event ) this.editing( false ); return null }
		@ $mol_action
		delete_skill( event?: Event ) {
			if( !event ) return null
			$mol_wire_sync( this.catalog() ).remove( this.selected() )
			this.editing( false ); this.selected( '' )
			return null
		}
		drag_locked() { return Boolean( this.query().trim() ) }
		drag_reversed() { return this.sort_order() === 'desc' }
		@ $mol_mem
		hierarchy() {
			const tree = this.catalog()?.tree() ?? new this.$.$shm_hitalama_skills_tree([])
			const query = this.query().trim().toLowerCase()
			if( !query ) return tree
			const keep = ( id: string, inherited = false ): boolean => {
				const entry = this.entry( id ), matches = inherited || ( entry.title() + ' ' + entry.name() ).toLowerCase().includes( query )
				const children = tree.children( id ).filter( child => keep( child, matches ) )
				tree.nodes.set( id, children )
				return matches || children.length > 0
			}
			tree.roots.splice( 0, tree.roots.length, ...tree.roots.filter( id => keep( id ) ) )
			return tree
		}
		roots() { const items = this.hierarchy().roots; return this.drag_reversed() ? [ ...items ].reverse() : items }
		children( id: string ) { const items = this.hierarchy().children( id ); return this.drag_reversed() ? [ ...items ].reverse() : items }
		@ $mol_mem_key
		expanded( id: string, next?: boolean ) { return this.$.$mol_state_local.value<boolean>( `${ this }.expanded(${ JSON.stringify( id ) })`, next ) ?? true }
		new_name_hint() { return this.create_kind() === 'group' ? 'Название группы' : 'Имя скилла, например hitalama-maps' }
		create_title() { return this.create_kind() === 'group' ? 'Создать группу' : 'Создать скилл' }
		add_content() { return [ this.create_kind() ? this.Create_form() : this.Add_menu() ] }
		folder_options() { return { '': 'Без группы', ...Object.fromEntries( ( this.catalog()?.entries() ?? [] ).filter( item => item.group() ).map( item => [ item.link().str, item.title() ] ) ) } }
		@ $mol_action
		add_enter( event?: MouseEvent ) { if( event ) { if( !this.Add().showed() ) this.create_kind( '' ); this.Add().event_show( event ) } return null }
		@ $mol_action
		add_open( event?: Event ) { if( event ) { this.create_kind( '' ); this.Add().hovered( true ) } return null }
		@ $mol_action
		add_keydown( event?: KeyboardEvent ) { if( event?.key === 'Escape' ) { event.preventDefault(); this.close_add() } return null }
		@ $mol_action
		close_add() { this.Add().hovered( false ); this.List().focused( true ) }
		@ $mol_action
		start_create( kind: string, parent = '' ) {
			this.new_name( '' ); this.new_parent( parent ); this.create_kind( kind )
			this.Add_anchor().focused( true ); this.Add().hovered( true )
		}
		@ $mol_action
		add_group( event?: Event ) { if( event ) this.start_create( 'group' ); return null }
		@ $mol_action
		add_skill( event?: Event ) { if( event ) this.start_create( 'skill' ); return null }
		@ $mol_action
		add_skill_in( id: string, event?: Event ) { if( event ) { this.Item( id ).Menu().showed( false ); this.start_create( 'skill', id ) } return null }
		@ $mol_action
		add_group_in( id: string, event?: Event ) { if( event ) { this.Item( id ).Menu().showed( false ); this.start_create( 'group', id ) } return null }
		@ $mol_action
		cancel_create( event?: Event ) { if( event ) this.create_kind( '' ); return null }
		@ $mol_action
		create( event?: Event ) {
			if( !event ) return null
			const catalog = $mol_wire_sync( this.$.$shm_hitalama_skills_catalog ).ensure()
			const entry = $mol_wire_sync( catalog ).create( event, this.create_kind(), this.new_name(), this.new_parent() )
			if( !entry.group() ) { this.selected( entry.link().str ); this.editing( true ) }
			this.close_add(); this.create_kind( '' )
			return null
		}
	}
}
